import { useQuery } from '@tanstack/react-query';
import { calendarsApi } from '@/api/calendars';
import { queryKeys } from '@/query/queryKeys';

const useCalendarsQuery = () =>
  useQuery({
    queryKey: queryKeys.calendars(),
    queryFn: () => calendarsApi.list(),
  });

export { useCalendarsQuery };
